export default "__VITE_ASSET__mSJZOpWF__"